import React from "react";

const NmsTableSearch = ({ value, onChange, placeholder = "Search" }) => (
  <label className="inc-table-search">
    <i className="fa fa-search" aria-hidden="true" />
    <input
      type="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  </label>
);

const readField = (row, key) => {
  const path = String(key || "").split(".");
  let value = row;
  for (const part of path) value = value?.[part];
  if (Array.isArray(value)) return value.join(" ");
  if (value && typeof value === "object") return JSON.stringify(value);
  return value;
};

export const searchRows = (rows, query, fields) => {
  const needle = String(query || "").trim().toLowerCase();
  if (!needle) return rows || [];
  return (rows || []).filter((row) => {
    if (fields?.length) {
      return fields.some((key) =>
        String(readField(row, key) ?? "")
          .toLowerCase()
          .includes(needle)
      );
    }
    try {
      return JSON.stringify(row).toLowerCase().includes(needle);
    } catch {
      return false;
    }
  });
};

export const sortRows = (rows, key, direction) => {
  if (!key || !direction) return rows || [];
  const list = [...(rows || [])];
  const dir = direction === "desc" ? -1 : 1;
  list.sort((a, b) => {
    const av = readField(a, key);
    const bv = readField(b, key);
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    const an = Number(av);
    const bn = Number(bv);
    if (
      String(av).trim() !== "" &&
      String(bv).trim() !== "" &&
      !Number.isNaN(an) &&
      !Number.isNaN(bn)
    ) {
      return (an - bn) * dir;
    }
    return (
      String(av).localeCompare(String(bv), undefined, {
        numeric: true,
        sensitivity: "base",
      }) * dir
    );
  });
  return list;
};

export default NmsTableSearch;
